import React, { useState } from "react";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import { Button } from "../../../../stories/Button/Button";
import { Modal } from "react-bootstrap";
import classes from "./SaveFilterModal.module.css";
import ModalSkeleton from "../ModalSkeleton/ModalSkeleton";
import { starIconss } from "../../../../constant/imagePath";
import { Input } from "../../../../stories/Input/Input";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";

const SaveFilterModal = ({ show, setShow }) => {
  const [saveFilterState, setSaveFilterState] = useState();

  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius={"20px"}
        width={"468px"}
        height={"188px"}
        padding={"32px"}
        showCloseIcon={true}
        footer={
          <div className={classes.btnsBox}>
            <LinkButtonWithIcon
              primary={false}
              text={'Cancel'}
              customStyle={{ marginRight: '48px', color: Colors.neutralShadesOfNero }}
            />
            <Button
              size="small"
              label="Save"
              style={{
                backgroundColor: Colors.mainShadeOfRed,
                color: Colors.white,
                width: "120px",
              }}
            />
          </div>

        }
      >
        <div className={classes.modalContent}>
          <h4 style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}>
            Save Filter
          </h4>

          <div className={classes.wrapperTextarea}>
            <Input
              // label={"Filter Name"}
              state={saveFilterState}
              setter={setSaveFilterState}
              placeholder={"Filter Name"}
            />
          </div>
          {/* <Modal.Footer> */}
          {/* </Modal.Footer> */}
        </div>
      </ModalSkeleton>
    </>
  );
};

export default SaveFilterModal;
